/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Message } from 'CalltakingCoreApi';
import { MessageService } from './message.service';
import { deleteSmsMessage, fetchPredefinedSmsMessages, initializeSmsMessageState, newSmsMessage, updateSmsMessage } from '../+state/message.actions';
import { ClusterUrlProviderService } from '../../core/services/cluster-url-provider.service';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({
    providedIn: 'root'
})
export class SmsMessageService extends MessageService {

    constructor(
        private http: HttpClient,
        protected store: Store,
        private clusterUrlProviderService: ClusterUrlProviderService,
        protected stompManager: StompManagerService
    ) {
        super('SMS', store, stompManager);
    }

    protected getTopics(): Topic[] {
        return [Topic.MESSAGES_SMS_NEW, Topic.MESSAGES_SMS_EDIT, Topic.MESSAGES_SMS_DELETE];
    }

    protected getTopicHandlers(): { [topic in Topic]?: (message: any) => void } {
        return {
            [Topic.MESSAGES_SMS_NEW]: this.newMessage.bind(this),
            [Topic.MESSAGES_SMS_EDIT]: this.editMessage.bind(this),
            [Topic.MESSAGES_SMS_DELETE]: this.deleteMessage.bind(this)
        };
    }

    protected effectsInitialized(): void {
        this.store.dispatch(fetchPredefinedSmsMessages());
    }

    protected websocketInitialized(clusterName?: string): void {
        this.store.dispatch(initializeSmsMessageState({ clusterName: clusterName }));
    }

    protected deleteMessage(message: Message): void {
        this.store.dispatch(deleteSmsMessage({ message }));
    }

    protected editMessage(message: Message): void {
        this.store.dispatch(updateSmsMessage({ message }));
    }

    protected newMessage(message: Message): void {
        this.store.dispatch(newSmsMessage({ message }));
    }

    public requestSmsMessages(callId: string, clusterName: string) {
        const url = this.clusterUrlProviderService.getClusterSpecificUrl(clusterName, `${this.API_BASE_URL}${callId}/load/${this.type}`);
        return this.http.get<Message[]>(url, { observe: 'body', responseType: 'json' });
    }
}
